var _rect, _rect2, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "url(#paint0_linear_323_12799)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#51CF66",
    fillOpacity: 0.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6953 5.01562H8.67188C6.60938 5.01562 5.625 5.83594 5.625 8.29688V11.1562V18.3281C5.625 18.75 5.85938 18.9844 6.30469 18.9844H8.22656C8.69531 18.9844 8.90625 18.75 8.90625 18.3281V14.9998L8.91027 15C8.91027 14.5781 9.11719 14.3438 9.58594 14.3438H13.3828C13.8516 14.3438 14.0625 14.1094 14.0625 13.6875V11.8125C14.0625 11.3906 13.8516 11.1562 13.3828 11.1562H8.90625V8.95312C8.90625 8.53125 9.11719 8.29688 9.58594 8.29688H17.6953C18.1641 8.29688 18.375 8.0625 18.375 7.64062V5.67188C18.375 5.25 18.1645 5.01562 17.6953 5.01562ZM17.475 15.7969C17.79 15.7969 17.9475 15.7969 18.0679 15.8582C18.1737 15.9121 18.2598 15.9982 18.3137 16.104C18.375 16.2243 18.375 16.3818 18.375 16.6969V18.0844C18.375 18.3994 18.375 18.5569 18.3137 18.6772C18.2598 18.7831 18.1737 18.8691 18.0679 18.9231C17.9475 18.9844 17.79 18.9844 17.475 18.9844H16.0875C15.7725 18.9844 15.615 18.9844 15.4946 18.9231C15.3888 18.8691 15.3027 18.7831 15.2488 18.6772C15.1875 18.5569 15.1875 18.3994 15.1875 18.0844V16.6969C15.1875 16.3818 15.1875 16.2243 15.2488 16.104C15.3027 15.9982 15.3888 15.9121 15.4946 15.8582C15.615 15.7969 15.7725 15.7969 16.0875 15.7969H17.475Z",
    fill: "url(#paint1_linear_323_12799)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6953 5.01562H8.67188C6.60938 5.01562 5.625 5.83594 5.625 8.29688V11.1562V18.3281C5.625 18.75 5.85938 18.9844 6.30469 18.9844H8.22656C8.69531 18.9844 8.90625 18.75 8.90625 18.3281V14.9998L8.91027 15C8.91027 14.5781 9.11719 14.3438 9.58594 14.3438H13.3828C13.8516 14.3438 14.0625 14.1094 14.0625 13.6875V11.8125C14.0625 11.3906 13.8516 11.1562 13.3828 11.1562H8.90625V8.95312C8.90625 8.53125 9.11719 8.29688 9.58594 8.29688H17.6953C18.1641 8.29688 18.375 8.0625 18.375 7.64062V5.67188C18.375 5.25 18.1645 5.01562 17.6953 5.01562ZM17.475 15.7969C17.79 15.7969 17.9475 15.7969 18.0679 15.8582C18.1737 15.9121 18.2598 15.9982 18.3137 16.104C18.375 16.2243 18.375 16.3818 18.375 16.6969V18.0844C18.375 18.3994 18.375 18.5569 18.3137 18.6772C18.2598 18.7831 18.1737 18.8691 18.0679 18.9231C17.9475 18.9844 17.79 18.9844 17.475 18.9844H16.0875C15.7725 18.9844 15.615 18.9844 15.4946 18.9231C15.3888 18.8691 15.3027 18.7831 15.2488 18.6772C15.1875 18.5569 15.1875 18.3994 15.1875 18.0844V16.6969C15.1875 16.3818 15.1875 16.2243 15.2488 16.104C15.3027 15.9982 15.3888 15.9121 15.4946 15.8582C15.615 15.7969 15.7725 15.7969 16.0875 15.7969H17.475Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_323_12799",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 5,
    width: 14,
    height: 14
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6953 5.01562H8.67188C6.60938 5.01562 5.625 5.83594 5.625 8.29688V11.1562V18.3281C5.625 18.75 5.85938 18.9844 6.30469 18.9844H8.22656C8.69531 18.9844 8.90625 18.75 8.90625 18.3281V14.9998L8.91027 15C8.91027 14.5781 9.11719 14.3438 9.58594 14.3438H13.3828C13.8516 14.3438 14.0625 14.1094 14.0625 13.6875V11.8125C14.0625 11.3906 13.8516 11.1562 13.3828 11.1562H8.90625V8.95312C8.90625 8.53125 9.11719 8.29688 9.58594 8.29688H17.6953C18.1641 8.29688 18.375 8.0625 18.375 7.64062V5.67188C18.375 5.25 18.1645 5.01562 17.6953 5.01562ZM17.475 15.7969C17.79 15.7969 17.9475 15.7969 18.0679 15.8582C18.1737 15.9121 18.2598 15.9982 18.3137 16.104C18.375 16.2243 18.375 16.3818 18.375 16.6969V18.0844C18.375 18.3994 18.375 18.5569 18.3137 18.6772C18.2598 18.7831 18.1737 18.8691 18.0679 18.9231C17.9475 18.9844 17.79 18.9844 17.475 18.9844H16.0875C15.7725 18.9844 15.615 18.9844 15.4946 18.9231C15.3888 18.8691 15.3027 18.7831 15.2488 18.6772C15.1875 18.5569 15.1875 18.3994 15.1875 18.0844V16.6969C15.1875 16.3818 15.1875 16.2243 15.2488 16.104C15.3027 15.9982 15.3888 15.9121 15.4946 15.8582C15.615 15.7969 15.7725 15.7969 16.0875 15.7969H17.475Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_323_12799)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.90625 9.14062V8.01562C8.90625 5.95312 9.72656 5.01562 11.9062 5.01562V9.14062H8.90625Z",
    fill: "url(#paint2_linear_323_12799)",
    style: {
      mixBlendMode: "multiply"
    }
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_323_12799",
    x1: 24,
    y1: 0,
    x2: 0,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3FEB5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0DCB2A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_323_12799",
    x1: 4.47857,
    y1: 5.01562,
    x2: 4.47857,
    y2: 18.9844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#15C040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15C040"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_323_12799",
    x1: 8.41762,
    y1: 10.1335,
    x2: 11.9062,
    y2: 10.1335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFc);
export default __webpack_public_path__ + "static/media/FC.1d7227cbe8b7b39a604a622a518dc498.svg";
export { ForwardRef as ReactComponent };